import React, { Component } from "react";
import NumberFormat from "react-number-format";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import "../AllPrint.css";
import n2wordsEN from "n2words/lib/i18n/AR.mjs";
import { FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
class SellPrintArabic extends Component {
 render() {
  const {
   lang,
   change_Lang,
   sell_invoice_obj,
   user,
   thirdcolor,
   primary_logo,
   index_sell_contract,
   footer_logo,
   name_arb,
  } = this.props;
  // Arbic
  let numWords1 =
   sell_invoice_obj.introduction !== undefined &&
   sell_invoice_obj.introduction !== null
    ? n2wordsEN(sell_invoice_obj.introduction)
    : 0;
  let numWords2 =
   sell_invoice_obj.lastPrice !== undefined &&
   sell_invoice_obj.lastPrice !== null
    ? n2wordsEN(sell_invoice_obj.lastPrice)
    : 0;
  let numWords3 =
   sell_invoice_obj.reject !== undefined && sell_invoice_obj.reject !== null
    ? n2wordsEN(sell_invoice_obj.reject)
    : 0;
  let numWords4 =
   sell_invoice_obj.pay !== undefined && sell_invoice_obj.pay !== null
    ? n2wordsEN(sell_invoice_obj.pay)
    : 0;
  let numWords5 =
   sell_invoice_obj.fee !== undefined && sell_invoice_obj.fee !== null
    ? n2wordsEN(sell_invoice_obj.fee)
    : 0;
  return (
   <>
    {/* New One */}
    <div className={`${lang === "en" ? "" : "container-fluid fk "}`}>
     <div className="row">
      <div className="col-12">
       <div className="conn content-containers" id="tbls">
        <div class="row">
         <div class="col-12  ">
          <img
           src={primary_logo}
           alt="logo"
           style={{ width: "100%" }}
           className="img-fluid img-responsive"
          />
         </div>
        </div>
        <div class="row mt-3">
         <div class="col-4">
          <p
           style={{
            fontSize: "22px",
            color: "#000",
            textAlign: "right",
            fontWeight: "bold",
           }}
           class=" text-uppercase"
          >
           &nbsp;{change_Lang("date")} :&nbsp;
           <Time
            value={sell_invoice_obj.createdAt}
            format="hh:mm:ss"
            style={{
             fontSize: "22px",
             color: "#342800",
             fontWeight: "bold",
            }}
           />
           &nbsp;-{" "}
           <Time
            value={sell_invoice_obj.createdAt}
            format="YYYY-MM-DD"
            style={{
             fontSize: "22px",
             color: "#000",
             fontWeight: "bold",
            }}
           />
          </p>
         </div>
         <div class="col-4 d-flex justify-content-center">
          <p
           style={{
            fontSize: "25px",
            color: "#000",
            fontWeight: "bolder",
           }}
           class={`d-flex justify-content-center text-uppercase ${
            lang !== "en" ? "fk" : "fkp"
           } `}
          >
           ({change_Lang("sale and purchase contract")})
          </p>
         </div>
         <div class="col-4 text-right">
          <p
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bold",
           }}
           class=" text-uppercase"
          >
           {change_Lang("contract number")} # &nbsp;
           {index_sell_contract}&nbsp;
          </p>
         </div>
        </div>
        <div class="row mt-1">
         <div class="col-12">
          <div class="form-group row form-inline">
           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-2 col-form-label"
           >
            {change_Lang("First Side")}:
           </label>
           <div class="col-sm-4">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {sell_invoice_obj.firstname}
            </label>
           </div>
           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-2 col-form-label"
           >
            {/* {change_Lang("Witness")}: */}
            {change_Lang("Second Side")}:
           </label>
           <div class="col-sm-4">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {sell_invoice_obj.secondname}
            </label>
           </div>
           {/* info */}
           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-2 col-form-label"
           >
            {change_Lang("resonated")}:
           </label>
           <div class="col-sm-4">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {sell_invoice_obj.info1}
            </label>
           </div>
           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-2 col-form-label"
           >
            {/* {change_Lang("Witness")}: */}
            {change_Lang("resonated")}:
           </label>
           <div class="col-sm-4">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {sell_invoice_obj.info2}
            </label>
           </div>
           {/* cards */}
           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-2 col-form-label"
           >
            {change_Lang("ID number")}:
           </label>
           <div class="col-sm-4">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {sell_invoice_obj.card1}
            </label>
           </div>
           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-2 col-form-label"
           >
            {/* {change_Lang("Witness")}: */}
            {change_Lang("ID number")}:
           </label>
           <div class="col-sm-4">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {sell_invoice_obj.card2}
            </label>
           </div>
           {/* phone */}
           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-2 col-form-label fkk"
           >
            {change_Lang("phone_number")}:
           </label>
           <div class="col-sm-4">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {sell_invoice_obj.phone1}
            </label>
           </div>

           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-2 col-form-label fkk"
           >
            {change_Lang("phone_number")}:
           </label>
           <div class="col-sm-4">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {sell_invoice_obj.phone2}
            </label>
           </div>
           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-2 col-form-label"
           >
            {" "}
            {change_Lang("first_rule_place")}:
           </label>
           <br />
           <div class="col-sm-4">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {sell_invoice_obj.available_id &&
              sell_invoice_obj.available_id.Place_ku}
            </label>
           </div>
           {/* shahed 2 */}
           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-2 col-form-label"
           >
            {" "}
            {/* {change_Lang("Witness")}: */}
            {change_Lang("Type of property")}:
           </label>
           <div class="col-sm-4">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {/* {sell_invoice_obj.witness2} */}
             {change_Lang(
              sell_invoice_obj.available_id &&
               sell_invoice_obj.available_id.Property
             )}
            </label>
           </div>
           {/* Area */}
           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-2 col-form-label"
           >
            {" "}
            {change_Lang("Number of property")}:
           </label>
           <br />
           <div class="col-sm-4">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {sell_invoice_obj.available_id &&
              sell_invoice_obj.available_id.NOoFProperty}
            </label>
           </div>
           {/* shahed 2 */}
           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-2 col-form-label"
           >
            {" "}
            {/* {change_Lang("Witness")}: */}
            {change_Lang("Area")}:
           </label>
           <div class="col-sm-4">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {/* {sell_invoice_obj.witness2} */}
             {sell_invoice_obj.available_id &&
              sell_invoice_obj.available_id.Area}
             &nbsp;م<sup>2</sup>
            </label>
           </div>
          </div>
          <p
           style={{
            fontSize: "22px",
            color: "#fff",
            fontWeight: "bolder",
            borderRadius: "50px 0px 0px 0px",
           }}
           id="liniar"
           class=" d-flex justify-content-center fk"
          >
           {change_Lang("agreement")}
          </p>
         </div>
        </div>
        <div className="row ">
         <div className="col-12">
          <table className="table">
           <tbody>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              1-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "2px",
               color: "black",
               fontWeight: "bold",
               textAlign: "justify",
               fontSize: "24px",
               borderTop: "none",
              }}
             >
              إني الطرف الأول ({sell_invoice_obj.firstname}) صاحب الملك وافقت
              على بيع العقار المذكور أعلاه بمبلغ قدره &nbsp;
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={sell_invoice_obj ? sell_invoice_obj.lastPrice : 0}
               required
               className="text-center"
               prefix={`${
                sell_invoice_obj.s_currency === "dolar" ? " $" : " IQD"
               }`}
              />
              &nbsp;({numWords2}
              &nbsp;
              {lang === "en" && sell_invoice_obj.s_currency === "dolar"
               ? "($)"
               : lang === "krd" && sell_invoice_obj.s_currency === "dolar"
               ? "دولار امریکي"
               : lang === "arb" && sell_invoice_obj.s_currency === "dolar"
               ? "دولار امریکي"
               : lang === "en" && sell_invoice_obj.s_currency !== "dolar"
               ? "(ID)"
               : lang === "krd" && sell_invoice_obj.s_currency !== "dolar"
               ? "دینار عراقي"
               : lang === "arb" && sell_invoice_obj.s_currency !== "dolar"
               ? "دینار عراقي"
               : ""}
              ).
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              2-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "2px",
               color: "black",
               fontWeight: "bold",
               textAlign: "justify",
               fontSize: "24px",
               borderTop: "none",
              }}
             >
              إني الطرف الثاني ({sell_invoice_obj.secondname}
              )وافقت على شراء العقار المذكور أعلاه بمبلغ قدره &nbsp;
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={sell_invoice_obj ? sell_invoice_obj.lastPrice : 0}
               required
               className="text-center"
               prefix={`${
                sell_invoice_obj.s_currency === "dolar" ? " $" : " IQD"
               }`}
              />
              &nbsp; ({numWords2}
              &nbsp;
              {lang === "en" && sell_invoice_obj.s_currency === "dolar"
               ? "($)"
               : lang === "krd" && sell_invoice_obj.s_currency === "dolar"
               ? "دولار امریکي"
               : lang === "arb" && sell_invoice_obj.s_currency === "dolar"
               ? "دولار امریکي"
               : lang === "en" && sell_invoice_obj.s_currency !== "dolar"
               ? "(ID)"
               : lang === "krd" && sell_invoice_obj.s_currency !== "dolar"
               ? "دینار عراقي"
               : lang === "arb" && sell_invoice_obj.s_currency !== "dolar"
               ? "دینار عراقي"
               : ""}
              ).
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              3-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "2px",
               color: "black",
               fontWeight: "bold",
               textAlign: "justify",
               fontSize: "24px",
               borderTop: "none",
              }}
             >
              يدفع الطرف الثاني مبلغاً قدره &nbsp;
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={sell_invoice_obj ? sell_invoice_obj.introduction : 0}
               required
               className="text-center"
               prefix={`${
                sell_invoice_obj.s_currency === "dolar" ? " $" : " IQD"
               }`}
              />
              &nbsp; ({numWords1}
              &nbsp;
              {lang === "en" && sell_invoice_obj.s_currency === "dolar"
               ? "($)"
               : lang === "krd" && sell_invoice_obj.s_currency === "dolar"
               ? "دولار امریکي"
               : lang === "arb" && sell_invoice_obj.s_currency === "dolar"
               ? "دولار امریکي"
               : lang === "en" && sell_invoice_obj.s_currency !== "dolar"
               ? "(ID)"
               : lang === "krd" && sell_invoice_obj.s_currency !== "dolar"
               ? "دینار عراقي"
               : lang === "arb" && sell_invoice_obj.s_currency !== "dolar"
               ? "دینار عراقي"
               : ""}
              ) &nbsp; تبقى في المكتب و المبلغ المتبقي &nbsp;(
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={sell_invoice_obj.pay}
               className="text-center"
               prefix={`${
                sell_invoice_obj.s_currency === "dolar" ? " $" : " IQD"
               }`}
              />
              &nbsp;
              {lang === "en"
               ? numWords4
               : lang === "krd"
               ? numWords4
               : numWords4}
              &nbsp;
              {lang === "en" && sell_invoice_obj.s_currency === "dolar"
               ? "($)"
               : lang === "krd" && sell_invoice_obj.s_currency === "dolar"
               ? "دولار امریکي"
               : lang === "arb" && sell_invoice_obj.s_currency === "dolar"
               ? "دولار امریکي"
               : lang === "en" && sell_invoice_obj.s_currency !== "dolar"
               ? "(ID)"
               : lang === "krd" && sell_invoice_obj.s_currency !== "dolar"
               ? "دینار عراقي"
               : lang === "arb" && sell_invoice_obj.s_currency !== "dolar"
               ? "دینار عراقي"
               : ""}
              )&nbsp; عليه أن يسلمها بعد إكمال عملية تحويل ملكية.
              {/* العقار في التاريخ &nbsp;({" "}
                            <Time
                              value={sell_invoice_obj.duedate}
                              format="YYYY-MM-DD"
                            />
                            )&nbsp; بطريقة ما (کاش-قسط) */}
             </td>
            </tr>

            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              4-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "2px",
               color: "black",
               fontWeight: "bold",
               textAlign: "justify",
               fontSize: "24px",
               borderTop: "none",
              }}
             >
              على الطرف الأول تسليم العقار إلى الطرف الثاني بعد استلام كافة
              مستحقاته المالية في &nbsp;
              <Time value={sell_invoice_obj.duedate} format="YYYY-MM-DD" />.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              5-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "2px",
               color: "black",
               fontWeight: "bold",
               textAlign: "justify",
               fontSize: "24px",
               borderTop: "none",
              }}
             >
              حال تأخر الطرف الأول من تسليم العقار إلى الطرف الثاني عليه دفع
              مبلغ قدره&nbsp;
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={sell_invoice_obj.reject}
               className="text-center"
               prefix={`${
                sell_invoice_obj.s_currency === "dolar" ? " $" : " IQD"
               }`}
              />
              &nbsp; ({numWords3}
              &nbsp;
              {lang === "en" && sell_invoice_obj.s_currency === "dolar"
               ? "($)"
               : lang === "krd" && sell_invoice_obj.s_currency === "dolar"
               ? "دولار امریکي"
               : lang === "arb" && sell_invoice_obj.s_currency === "dolar"
               ? "دولار امریکي"
               : lang === "en" && sell_invoice_obj.s_currency !== "dolar"
               ? "(ID)"
               : lang === "krd" && sell_invoice_obj.s_currency !== "dolar"
               ? "دینار عراقي"
               : lang === "arb" && sell_invoice_obj.s_currency !== "dolar"
               ? "دینار عراقي"
               : ""}
              ) &nbsp; كغرامة لكل يوم تأخير .
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              6-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "2px",
               color: "black",
               fontWeight: "bold",
               textAlign: "justify",
               fontSize: "24px",
               borderTop: "none",
              }}
             >
              على الطرف الأول تصفية تكاليف ورسومات الماء والكهرباء أو أي قرض آخر
              قبل موعد تسليم العقار المذكور.
             </td>
            </tr>
           </tbody>
          </table>
         </div>
        </div>
       </div>
       <div className="row content-containers" id="tbls_two">
        <div class="col-12  ">
         <img
          src={primary_logo}
          alt="logo"
          style={{ width: "100%" }}
          className="img-fluid img-responsive"
         />
        </div>
       </div>
       <div className="row">
        <div className="col-12">
         <table className="table">
          <tbody>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             7-
            </th>
            <td
             style={{
              lineHeight: "1.3",
              wordSpacing: "2px",
              color: "black",
              fontWeight: "bold",
              textAlign: "justify",
              fontSize: "24px",
              borderTop: "none",
             }}
            >
             في حال انسحاب أحد الطرفين، أياَ كان السبب، يجب دفع مبلغ قدره &nbsp;
             <NumberFormat
              displayType="text"
              thousandSeparator={true}
              value={sell_invoice_obj.fee}
              className="text-center"
              prefix={`${
               sell_invoice_obj.s_currency === "dolar" ? " $" : " IQD"
              }`}
             />
             &nbsp; ({numWords5}
             &nbsp;
             {lang === "en" && sell_invoice_obj.s_currency === "dolar"
              ? "($)"
              : lang === "krd" && sell_invoice_obj.s_currency === "dolar"
              ? "دولار امریکي"
              : lang === "arb" && sell_invoice_obj.s_currency === "dolar"
              ? "دولار امریکي"
              : lang === "en" && sell_invoice_obj.s_currency !== "dolar"
              ? "(ID)"
              : lang === "krd" && sell_invoice_obj.s_currency !== "dolar"
              ? "دینار عراقي"
              : lang === "arb" && sell_invoice_obj.s_currency !== "dolar"
              ? "دینار عراقي"
              : ""}
             ).
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             8-
            </th>
            <td
             style={{
              lineHeight: "1.3",
              wordSpacing: "2px",
              color: "black",
              fontWeight: "bold",
              textAlign: "justify",
              fontSize: "24px",
              borderTop: "none",
             }}
            >
             تقع تكاليف ورسومات البيع والنقل والفرز والتوحيد والتعديل وضريبة
             العقار على الطرف الأول وفق القانون إذا كان للعقار سند طابو. وفي حال
             لم يكن للعقار سند طابو على الطرف الأول دفع تكاليف اضافية لتحويل جنس
             العقار و من ثم نقل الملكية.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             9-
            </th>
            <td
             style={{
              lineHeight: "1.3",
              wordSpacing: "5px",
              color: "black",
              fontWeight: "bold",
              textAlign: "justify",
              fontSize: "22px",
              borderTop: "none",
             }}
            >
             يكون الطرف الأول مسؤولاً عن تسديد رسومات الكشف والتسجيل العقاري وفق
             القانون في حال كان للعقار سند طابو، وإذا لم يكن للعقار سند طابو على
             الطرفين دفع تكاليف التسجيل.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             10-
            </th>
            <td
             style={{
              lineHeight: "1.3",
              wordSpacing: "2px",
              color: "black",
              fontWeight: "bold",
              textAlign: "justify",
              fontSize: "24px",
              borderTop: "none",
             }}
            >
             بعد التوقيع على هذا العقد في حال كان للعقار المباع سند طابو، يجب
             على الطرف الأول منح وكالة إلى المحامي : &nbsp;(
             {sell_invoice_obj.lawman}
             )&nbsp; لغرض نقل الملكية وتسجيل العقار المباع لصالح الطرف الثاني.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             11-
            </th>
            <td
             style={{
              lineHeight: "1.3",
              wordSpacing: "2px",
              color: "black",
              fontWeight: "bold",
              textAlign: "justify",
              fontSize: "24px",
              borderTop: "none",
             }}
            >
             يتعهد الطرف الأول بدفع نسبة 1% من سعر العقار المذكور في هذا العقد
             إلى {name_arb} إزاء بيع العقار .
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             12-
            </th>
            <td
             style={{
              lineHeight: "1.3",
              wordSpacing: "2px",
              color: "black",
              fontWeight: "bold",
              textAlign: "justify",
              fontSize: "24px",
              borderTop: "none",
             }}
            >
             يتعهد الطرف الثاني بدفع نسبة 1% من سعر العقار المذكور في هذا العقد
             إلى {name_arb} إزاء شراء العقار.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             13-
            </th>
            <td
             style={{
              lineHeight: "1.3",
              wordSpacing: "2px",
              color: "black",
              fontWeight: "bold",
              textAlign: "justify",
              fontSize: "24px",
              borderTop: "none",
             }}
            >
             في حال حدوث أي نزاع حول مضمون هذا العقد على الطرفين حله عن طريق
             الحوار وإلا تكون محكمة أربيل محل بتّ القضايا.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             14-
            </th>
            <td
             style={{
              lineHeight: "1.3",
              wordSpacing: "5px",
              color: "black",
              fontWeight: "bold",
              textAlign: "justify",
              fontSize: "22px",
              borderTop: "none",
             }}
            >
             لا يحق للطرفين الأول والثاني في العقد المطالبة بالعمولة المدفوعة.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             15-
            </th>
            <td
             style={{
              lineHeight: "1.3",
              wordSpacing: "5px",
              color: "black",
              fontWeight: "bold",
              textAlign: "justify",
              fontSize: "22px",
              borderTop: "none",
             }}
            >
             {name_arb} العقارية ليست مسؤولة عن أي مشاكل تحدث بين البائع
             والمشتري فقط شاهدة على العقد.
            </td>
           </tr>
          </tbody>
         </table>
        </div>
       </div>
       <div className="form-inline">
        <label
         style={{
          fontSize: "19px",
          color: "black",
          textAlign: "justify",
          fontWeight: "bold",
         }}
         className="form-label d-flex justify-content-start"
        >
         {change_Lang("note")}&nbsp;:{sell_invoice_obj.note}
        </label>
       </div>
       <br /> <br /> <br /> <br /> <br />
       <div
        className="row"
        style={{
         width: "100%",
        }}
       >
        <div className="form-group d-flex justify-content-center col-3">
         <label
          style={{
           fontSize: "20px",
           color: "#000",
           fontWeight: "bolder",
          }}
          className="form-label"
         >
          الطرف الأول ( البائع)
         </label>
        </div>
        <div className="col-3">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bolder",
           }}
           className="form-label"
          >
           {change_Lang("Witness")}
          </label>
         </div>
        </div>
        <div className="col-3">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bolder",
           }}
           className="form-label"
          >
           {change_Lang("Witness")}
          </label>
         </div>
        </div>
        <div className="col-3">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bolder",
           }}
           className="form-label"
          >
           {change_Lang("Second Party (Buyer)")}
          </label>
         </div>
        </div>
       </div>
       <div
        className="row fkr"
        style={{
         width: "100%",
        }}
       >
        <div className="col-3 form-group d-flex justify-content-center fkr">
         <label
          style={{
           fontSize: "20px",
           color: "#000",
           fontWeight: "bold",
          }}
          className="form-label"
         >
          {sell_invoice_obj.firstname}
         </label>
        </div>
        <div className="col-3">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           {sell_invoice_obj.witness1}
          </label>
         </div>
        </div>
        <div className="col-3">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           {sell_invoice_obj.witness2}
          </label>
         </div>
        </div>
        <div className="col-3">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           {sell_invoice_obj.secondname}
          </label>
         </div>
        </div>
       </div>
      </div>
     </div>
    </div>
    {/* footer */}
    <div
     className="row"
     style={{
      position: "fixed",
      bottom: 47,
      width: "100%",
     }}
    >
     <div className="col-8 d-flex justify-content-end">
      <label
       style={{
        fontSize: 22,
        color: "#000",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
       }}
       className="fk"
      >
       {sell_invoice_obj.branchId ? sell_invoice_obj.branchId.adress : ""}
       &nbsp;&nbsp;
       <FaMapMarkerAlt
        style={{
         color: "#fff",
         background: " #000",
         padding: 5,
         fontSize: 25,
        }}
       />
      </label>
     </div>
     <div className="col-4 d-flex justify-content-end">
      <h4
       style={{
        fontSize: 21,
        color: "#black",
        letterSpacing: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        direction: "ltr",
        lineHeight: 1.5,
       }}
      >
       <FaPhoneAlt
        style={{
         color: "#fff",
         background: " #000",
         padding: 5,
         fontSize: 25,
         marginRight: 20,
        }}
       />
       {sell_invoice_obj.branchId
        ? sell_invoice_obj.branchId.adressNumber1
        : ""}{" "}
       <br />{" "}
       {sell_invoice_obj.branchId
        ? sell_invoice_obj.branchId.adressNumber2
        : ""}
      </h4>
     </div>
    </div>
    <div
     style={{
      position: "fixed",
      bottom: 0,
      width: "100%",
      zIndex: -1,
     }}
    >
     <img src={footer_logo} alt="logo" width="100%" />
    </div>
   </>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  sell_invoice_obj: state.Invoice_Reducer.sell_invoice_obj,
  index_sell_contract: state.Invoice_Reducer.index_sell_contract,
  user: state.AuthReducer.user,
  primarycolor: state.HelperReducer.primarycolor,
  secondarycolor: state.HelperReducer.secondarycolor,
  thirdcolor: state.HelperReducer.thirdcolor,
  primary_logo: state.HelperReducer.primary_logo,
  footer_logo: state.HelperReducer.footer_logo,
  name_arb: state.HelperReducer.name_arb,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(SellPrintArabic);
